"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopUpDialog = exports.topUpValidationSchema = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const mui_inputs_asset_1 = require("@dzambalaorg/mui-inputs-asset");
const types_1 = require("@framework/types");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const forms_1 = require("../../../../forms");
var validation_1 = require("./validation");
Object.defineProperty(exports, "topUpValidationSchema", { enumerable: true, get: function () { return validation_1.topUpValidationSchema; } });
const TopUpDialog = () => {
    return ((0, jsx_runtime_1.jsxs)(ui_kit_1.FormGrid, { columns: [1, 2], children: [(0, jsx_runtime_1.jsx)(forms_1.FormAlert, { message: "alert.allowanceErc20", condition: ({ token }) => token.components[0].tokenType === types_1.TokenType.ERC20 }), (0, jsx_runtime_1.jsx)(mui_inputs_asset_1.TokenAssetInput, { prefix: "token", tokenType: { disabledOptions: [types_1.TokenType.ERC721, types_1.TokenType.ERC998, types_1.TokenType.ERC1155] } }), (0, jsx_runtime_1.jsx)(ui_kit_1.FormGrid.Empty, {})] }));
};
exports.TopUpDialog = TopUpDialog;
//# sourceMappingURL=index.js.map